<template>
  <aha-modal
    :title="$i18nPresenter.t('sorry_to_see_you_go')"
    classesModal="modal-cancel-process modal-cancel-remind"
    @hide="handleCloseModal"
  >
    <div class="modal-content">
      <div class="img-presenter text-center pt-2 pb-6">
        <img
          class="inline-block"
          src="@/assets/images/cancel-subscription/remind.svg"
          width="274"
          height="183"
          alt=""
        >
      </div>
      <div class="font-bold">
        {{ $i18nPresenter.t('about_to_leave_behind') }}
      </div>
      <div class="stats">
        <div
          class="stats-row"
          :class="{
            crowded: isStatsCrowded
          }"
        >
          <div v-if="stats.eventHosted" class="stats-col">
            <div class="number">
              {{ stats.eventHosted }}
            </div>
            <div class="figcaption">
              {{ eventHostedText }}
            </div>
          </div>
          <div v-if="stats.participantEngaged" class="stats-col">
            <div class="number">
              {{ stats.participantEngaged }}
            </div>
            <div class="figcaption">
              {{ participantEngagedText }}
            </div>
          </div>
          <div v-if="stats.presentationCreated" class="stats-col">
            <div class="number">
              {{ stats.presentationCreated }}
            </div>
            <div class="figcaption">
              {{ presentationCreatedText }}
            </div>
          </div>
          <div v-if="stats.collaborator" class="stats-col">
            <div class="number">
              {{ stats.collaborator }}
            </div>
            <div class="figcaption">
              {{ collaboratorText }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #action>
      <aha-antd-button
        v-aha-emit-action
        name="cancel-subscription-remind-cancel"
        variant="secondary"
        class="text-base-80 font-bold cursor-pointer mr-5"
        @click="handleCloseModal"
      >
        {{ $i18nPresenter.t('Close') }}
      </aha-antd-button>
      <aha-antd-button
        v-aha-emit-action
        name="cancel-subscription-remind-continue"
        variant="primary"
        @click="handleNextStep"
      >
        {{ $i18nPresenter.t('Continue') }}
      </aha-antd-button>
    </template>
  </aha-modal>
</template>

<script>
import { mapState } from 'vuex'
import {
  CANCEL_SUBSCRIPTION_EVENT,
  CANCEL_SUBSCRIPTION_STEPS,
} from '@/constant/cancelSubscription'

export default {
  props: {
    propData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      plan: (state) => state.plan,
    }),
    stats() {
      if (!this.propData) return {}

      const eventHosted = this.propData.eventsHosted || 0
      const participantEngaged = this.propData.participantsEngaged || 0
      const presentationCreated = this.propData.presentationsCreated || 0
      const collaborator = this.propData.collaborators || 0

      return {
        eventHosted,
        participantEngaged,
        presentationCreated,
        collaborator,
      }
    },
    eventHostedText() {
      if (!this.stats) return ''

      const eventHostedKey = this.stats.eventHosted > 1
        ? 'event_hosted_other'
        : 'event_hosted'

      return this.$i18nPresenter.t(eventHostedKey)
    },
    participantEngagedText() {
      if (!this.stats) return ''

      const participantEngagedKey = this.stats.participantEngaged > 1
        ? 'participant_engaged_other'
        : 'participant_engaged'

      return this.$i18nPresenter.t(participantEngagedKey)
    },
    presentationCreatedText() {
      if (!this.stats) return ''

      const presentationCreatedKey = this.stats.presentationCreated > 1
        ? 'presentation_created_other'
        : 'presentation_created'

      return this.$i18nPresenter.t(presentationCreatedKey)
    },
    collaboratorText() {
      if (!this.stats) return ''

      const collaboratorKey = this.stats.collaborator > 1
        ? 'collaborator_other'
        : 'collaborator'

      return this.$i18nPresenter.t(collaboratorKey)
    },
    isStatsCrowded() {
      return this.stats
        && Object
          .values(this.stats)
          .filter((item) => item > 0)
          .length > 2
    },
  },
  mounted() {
    this._emitTrackEvent('Show Remind pop-up')
  },
  methods: {
    handleCloseModal() {
      this._emitTrackEvent('Remind pop-up > Close')
      this.$emit(CANCEL_SUBSCRIPTION_EVENT, CANCEL_SUBSCRIPTION_STEPS.END)
    },
    handleNextStep() {
      this._emitTrackEvent('Remind pop-up > Continue')
      this.$emit(CANCEL_SUBSCRIPTION_EVENT, CANCEL_SUBSCRIPTION_STEPS.OPTION_SELECTION)
    },
    _emitTrackEvent(action) {
      this.$emit('trackEvent', {
        eventAction: `Cancel subscription > ${action}`,
        eventLabel: {
          eventHostedCount: this.stats.eventHosted,
          participantsEngagedCount: this.stats.participantEngaged,
          presentationsCreatedCount: this.stats.presentationCreated,
          collaboratorsCount: this.stats.collaborator,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.stats {
  @apply pt-4 pb-2;

  &-row {
    @apply flex flex-wrap border-t border-b border-base-30;

    &.crowded {
      .stats-col:nth-child(1),
      .stats-col:nth-child(2) {
        @apply border-b border-base-30;
      }
    }
  }

  &-col {
    @apply py-4 w-1/2;

    .number {
      @apply text-primary-90 font-bold text-xl;
    }

    .figcaption {
      @apply text-base-90 text-sm;
    }
  }
}
</style>
